import React from 'react';
import { Button, Input, Select, Radio } from 'antd';
import EligibilityConditionsBau from './EligibilityConditions/EligibilityConditionsBau';
import EligibilityConditionsLifecycle from './EligibilityConditions/EligibilityConditionsLifecycle';

const { Option } = Select;

const StepEligibilityConditions = ({ onNext, onBack, formData, updateField }) => {
  const selectedRuleType = formData?.ruleType || 'BAU';

  return (
    <div className='step-container'>
      <div className='step-content'>
        <div className='step-header'>
          <div className='step-title'>Eligibility Conditions</div>
        </div>

        <div className='step-form d-flex d-flex-row justifyContentSpaceBetween border-bottom-light'>
          <div className='step-group w-50'>
            <div className='step-form-label'>Rule Type</div>
            <div className='RadioGroup'>
              <Radio.Group
                value={selectedRuleType}
                onChange={(e) => updateField('ruleType', e.target.value)}
              >
                <Radio.Button value='BAU'>BAU</Radio.Button>
                <Radio.Button value='Lifecycle Triggered'>Lifecycle Triggered</Radio.Button>
              </Radio.Group>
            </div>
          </div>
          <div className='step-group w-50'>
            <div className='step-form-label'>Member Type</div>
            <div className='RadioGroup'>
              <Radio.Group
                value={formData?.memberType || 'Member'}
                onChange={(e) => updateField('memberType', e.target.value)}
              >
                <Radio.Button value='Member'>Member</Radio.Button>
                <Radio.Button value='Prive'>Prive</Radio.Button>
              </Radio.Group>
            </div>
          </div>
        </div>

        <div className='step-content-body mt-16'>
          {selectedRuleType === 'Lifecycle Triggered' ? (
            <EligibilityConditionsLifecycle formData={formData} updateField={updateField} />
          ) : (
            <EligibilityConditionsBau formData={formData} updateField={updateField} />
          )}
        </div>
      </div>
    </div>
  );
};

export default StepEligibilityConditions;
